import { Pipe, PipeTransform } from '@angular/core';
import {CompetitorTableComponent, CompetitorTableRowData, CompetitorTableType} from "@components";
import {ApplicationFormSettings, RaceSettings, TeamType, VisibilityTypes, EventItem} from "@model";

@Pipe({
  name: 'filterCompetitorTableRowData',
})
export class FilterCompetitorTableRowDataPipe implements PipeTransform {
  transform(fields: (keyof CompetitorTableRowData | string)[]): (keyof CompetitorTableRowData)[] {
    return fields.filter(field => !(field.startsWith(CompetitorTableComponent.CUSTOM_FIELD_COLUMN_PREFIX) || field.startsWith(CompetitorTableComponent.ADDITIONAL_PRICING_ITEM_COLUMN_PREFIX))) as (keyof CompetitorTableRowData)[];
  }
}

@Pipe({
  name: 'competitorMobileFields',
})
export class CompetitorMobileFieldsPipe implements PipeTransform {
  transform(
      competitor: CompetitorTableRowData,
      raceSettingsList: RaceSettings[],
      applicationFromSettingsList: ApplicationFormSettings[],
      tableMode: CompetitorTableType,
      allowedVisibilityTypes: VisibilityTypes[],
      isAdmin: boolean,
      event: EventItem | undefined,
      isTeamMember: boolean = false
  ): (keyof CompetitorTableRowData)[] {
    const fields: (keyof CompetitorTableRowData)[] = [];
    const raceSettings = raceSettingsList.find(r => r.raceId === competitor.raceId);
    const applicationFormSettings = applicationFromSettingsList.find(r => r.raceId === competitor.raceId);

    if (!raceSettings || !applicationFormSettings) return fields;

    const visibilityIncludes = (v: VisibilityTypes | undefined) => v && allowedVisibilityTypes.includes(v);

    if (isTeamMember) {
      fields.push('fullName');
      if (visibilityIncludes(applicationFormSettings.genderVisibility)) fields.push('sex');
      if (visibilityIncludes(applicationFormSettings.countryVisibility)) fields.push('countryShort');
    } else if (raceSettings.teamType && raceSettings.teamType !== TeamType.SINGLE && tableMode !== CompetitorTableType.TEAM_MEMBER_VIEW) {
      fields.push('teamName', 'startNumber', 'teamMembers', 'paymentStatus');
    } else {
      fields.push('startNumber', 'fullName');
      if (visibilityIncludes(applicationFormSettings.genderVisibility)) fields.push('sex');
      if (visibilityIncludes(applicationFormSettings.countryVisibility)) fields.push('countryShort');
      if (visibilityIncludes(applicationFormSettings.clubVisibility)) fields.push('club');
      if (isAdmin || event?.paymentSettings?.displayPaymentStatusForRegistrants) {
        fields.push('paymentStatus');
      }
      if (visibilityIncludes(applicationFormSettings.categoryRegistrationVisibility)) {
        fields.push('categoryLabel');
      }
    }

    return fields;
  }
}
